// import * as THREE from "./three.module.js";
// import { GLTFLoader } from "./GLTFLoader.js";

// import * as THREE from "https://unpkg.com/three@0.179.1/build/three.module.js?module";
// import { GLTFLoader } from "https://unpkg.com/three@0.179.1/examples/jsm/loaders/GLTFLoader.js?module";
// // import { start } from "./utilities";

// const scene = new THREE.Scene();

// const camera = new THREE.PerspectiveCamera(
//   45,
//   window.innerWidth / window.innerHeight,
//   0.1,
//   1000,
// );

// camera.position.z = 5;

// const renderer = new THREE.WebGLRenderer({
//   alpha: true,
//   antialias: true,
// });

// // renderer.setSize(window.innerWidth, window.innerHeight);
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// renderer.setSize(window.innerWidth, window.innerHeight);

// renderer.outputColorSpace = THREE.SRGBColorSpace;

// // renderer.domElement.style.position = "fixed";
// // renderer.domElement.style.top = "0";
// // renderer.domElement.style.left = "0";
// // renderer.domElement.style.width = "100vw";
// // renderer.domElement.style.height = "100vh";
// // renderer.domElement.style.zIndex = "9999";
// // document.body.appendChild(renderer.domElement);
// // document.getElementById("three-container").appendChild(renderer.domElement);

// function onResize() {
//   camera.aspect = window.innerWidth / window.innerHeight;

//   camera.updateProjectionMatrix();

//   renderer.setSize(window.innerWidth, window.innerHeight);

//   renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

//   ScrollTrigger.refresh();
// }

// window.addEventListener("resize", onResize);

// document.querySelector("#MainContent").appendChild(renderer.domElement);

// let bottle;

// function animate() {
//   requestAnimationFrame(animate);

//   //   if (bottle) {
//   //     bottle.rotation.y += 0.01;
//   //   }

//   renderer.render(scene, camera);
// }

// const ambientLight = new THREE.AmbientLight(0xffffff, 2);
// scene.add(ambientLight);

// const directionalLight = new THREE.DirectionalLight(0xffffff, 3);
// directionalLight.position.set(5, 5, 5);
// scene.add(directionalLight);

// animate();

// //................

// const loader = new GLTFLoader();

// loader.load(window.BOTTLE_URL, (gltf) => {
//   bottle = gltf.scene;
//   scene.add(bottle);
//   window.bottle = bottle;

//   console.log("Bottle Loaded!");

// bottle.position.x += 0.3;
// bottle.position.y -= 0.8;
// bottle.rotation.x += 1;
// bottle.scale.set(0.35, 0.35, 0.35);
// bottle.rotation.set(
//   THREE.MathUtils.degToRad(-90),
//   THREE.MathUtils.degToRad(96),
//   THREE.MathUtils.degToRad(90),
// );

// const mm = gsap.matchMedia();
// const layouts = {
//   desktop: {
//     hero: {
//       x: 0.3,
//       y: -0.8,
//       scale: 0.35,
//       rotation: 96,
//     },

//     text: {
//       x: 1.8,
//       y: -0.8,
//       scale: 0.35,
//       rotation: 106,
//     },

//     grid: {
//       x: -0.6,
//       y: 1,
//       scale: 0.2,
//       rotation: 103,
//     },
//   },

//   tablet: {
//     hero: {
//       x: 0.15,
//       y: -0.55,
//       scale: 0.3,
//       rotation: 96,
//     },

//     text: {
//       x: 1.1,
//       y: -0.45,
//       scale: 0.28,
//       rotation: 104,
//     },

//     grid: {
//       x: -0.3,
//       y: 0.8,
//       scale: 0.2,
//       rotation: 103,
//     },
//   },

//   mobile: {
//     hero: {
//       x: 0,
//       y: -0.35,
//       scale: 0.22,
//       rotation: 96,
//     },

//     text: {
//       x: 0.45,
//       y: -0.15,
//       scale: 0.22,
//       rotation: 102,
//     },

//     grid: {
//       x: 0,
//       y: 0.65,
//       scale: 0.18,
//       rotation: 103,
//     },
//   },
// };

// function applyLayout(state) {
//   gsap.set(bottle.position, {
//     x: state.x,
//     y: state.y,
//   });

//   gsap.set(bottle.scale, {
//     x: state.scale,
//     y: state.scale,
//     z: state.scale,
//   });

//   gsap.set(bottle.rotation, {
//     x: THREE.MathUtils.degToRad(-90),
//     y: THREE.MathUtils.degToRad(state.rotation),
//     z: THREE.MathUtils.degToRad(90),
//   });
// }
// // GPT
// mm.add("(min-width:1024px)", () => {
//   applyLayout(layouts.desktop.hero);

//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".custom-text-container",

//       start: "top 70%",

//       end: "top 30%",

//       scrub: 1.5,
//     },
//   });

//   tl.to(
//     bottle.position,
//     {
//       x: layouts.desktop.text.x,

//       y: layouts.desktop.text.y,
//     },
//     0,
//   )

//     .to(
//       bottle.scale,
//       {
//         x: layouts.desktop.text.scale,

//         y: layouts.desktop.text.scale,

//         z: layouts.desktop.text.scale,
//       },
//       0,
//     )

//     .to(
//       bottle.rotation,
//       {
//         y: THREE.MathUtils.degToRad(layouts.desktop.text.rotation),
//       },
//       0,
//     );
// });

// const tl2 = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",

//     start: "top 80%",

//     end: "top 35%",

//     scrub: 1.5,
//   },
// });

// tl2
//   .to(
//     bottle.position,
//     {
//       x: layouts.desktop.grid.x,

//       y: layouts.desktop.grid.y,
//     },
//     0,
//   )

//   .to(
//     bottle.scale,
//     {
//       x: layouts.desktop.grid.scale,

//       y: layouts.desktop.grid.scale,

//       z: layouts.desktop.grid.scale,
//     },
//     0,
//   )

//   .to(
//     bottle.rotation,
//     {
//       y: THREE.MathUtils.degToRad(layouts.desktop.grid.rotation),
//     },
//     0,
//   );

// mm.add("(min-width:768px)", () => {
//   applyLayout(layouts.mobile.hero);

//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".custom-text-container",

//       start: "top 70%",

//       end: "top 30%",

//       scrub: 1.5,
//     },
//   });

//   tl.to(
//     bottle.position,
//     {
//       x: layouts.mobile.text.x,

//       y: layouts.mobile.text.y,
//     },
//     0,
//   )

//     .to(
//       bottle.scale,
//       {
//         x: layouts.mobile.text.scale,

//         y: layouts.mobile.text.scale,

//         z: layouts.mobile.text.scale,
//       },
//       0,
//     )

//     .to(
//       bottle.rotation,
//       {
//         y: THREE.MathUtils.degToRad(layouts.mobile.text.rotation),
//       },
//       0,
//     );
// });

// const tl3 = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",

//     start: "top 80%",

//     end: "top 35%",

//     scrub: 1.5,
//   },
// });

// tl3
//   .to(
//     bottle.position,
//     {
//       x: layouts.mobile.grid.x,

//       y: layouts.mobile.grid.y,
//     },
//     0,
//   )

//   .to(
//     bottle.scale,
//     {
//       x: layouts.mobile.grid.scale,

//       y: layouts.mobile.grid.scale,

//       z: layouts.mobile.grid.scale,
//     },
//     0,
//   )

//   .to(
//     bottle.rotation,
//     {
//       y: THREE.MathUtils.degToRad(layouts.mobile.grid.rotation),
//     },
//     0,
//   );

// MYGSAP
// gsap.to("#MainContent canvas", {
//   y: "105%",
//   duration: 1.3,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-text-container",
//     start: "top 70%",
//     end: "top 30%",
//     markers: true,
//     scrub: 2,
//   },
// });

// gsap.to(bottle.position, {
//   x: 1.8,
//   // y: -1,
//   duration: 0.5,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-text-container",
//     start: "top 70%",
//     end: "top 30%",
//     marker: true,
//     scrub: 2,
//   },
// });

// gsap.to(bottle.rotation, {
//   y: THREE.MathUtils.degToRad(106),
//   duration: 0.5,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-text-container",
//     start: "top 70%",
//     end: "top 30%",
//     marker: true,
//     scrub: 2,
//   },
// });

// // Third Screen
// gsap.to("#MainContent canvas", {
//   y: "+=105%",
//   duration: 1.3,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",
//     start: "top 80%",
//     end: "top 35%",
//     // markers: true,
//     scrub: 2,
//   },
// });

// gsap.to(bottle.position, {
//   x: -0.6,
//   y: 1,
//   duration: 0.5,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",
//     start: "top 80%",
//     end: "top 35%",
//     // marker: true,
//     scrub: 2,
//   },
// });

// gsap.to(bottle.rotation, {
//   y: THREE.MathUtils.degToRad(103),
//   duration: 0.5,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",
//     start: "top 80%",
//     end: "top 35%",
//     // marker: true,
//     scrub: 2,
//   },
// });

// gsap.to(bottle.scale, {
//   x: 0.2,
//   y: 0.2,
//   z: 0.2,
//   duration: 0.5,
//   ease: "sine.in",
//   scrollTrigger: {
//     trigger: ".custom-grid-layout-container",
//     start: "top 80%",
//     end: "top 35%",
//     // marker: true,
//     scrub: 2,
//   },
// });
// });

// console.log("Three App Loaded");

// ?? New ??



// GSAP
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("shopify:section:load", function () {
    ScrollTrigger.refresh();
  });

  // let navbarTimeLine = gsap.timeline();

  // navbarTimeLine.from(".custom-header-logo a", {
  //   //   y: -60,
  //   opacity: 0,
  //   duration: 1.5,
  //   delay: 0.5,
  //   ease: "expoScale(0.5,7,none)",
  // });

  // navbarTimeLine.from(".custom-header-menu-link", {
  //   y: -50,
  //   opacity: 0,
  //   duration: 0.5,
  //   // delay: .5,
  //   stagger: 0.3,
  // });

  // navbarTimeLine.from(".custom-header-icons-wrapper", {
  //   //   y: -60,
  //   opacity: 0,
  //   duration: 1.5,
  //   //   delay: .5
  // });

  gsap.from(".custom-hero-banner-container", {
    y: 20,
    opacity: 0,
    duration: 1.5,
    delay: 1.5,
    scrollTrigger: {
      trigger: ".custom-hero-banner-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-text p", {
    y: "100%",
    opacity: 1,
    duration: 0.8,
    ease: "expoScale(0.5,7,none)",

    scrollTrigger: {
      trigger: "#text-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-image", {
    x: "100%",
    opacity: 1,
    duration: 0.8,
    ease: "power4.out",
    scrollTrigger: {
      trigger: "#text-container",
      scroller: "body",
      start: "top 50%",
    },
  });

  gsap.utils.toArray(".custom-product-features-wrapper").forEach((section) => {
    gsap.from(section.querySelectorAll(".custom-product-feature-card"), {
      y: 100,
      opacity: 1,
      duration: 0.6,
      delay: 0.4,
      ease: "back.out(1.7)",
      scrollTrigger: {
        trigger: section,
        scroller: "body",
        // markers: true,
        start: "top 50%",
      },
    });
  });

  gsap.from(".custom-video-container", {
    opacity: 1,
    duration: 1.5,
    ease: "power4.out",
    scrollTrigger: {
      trigger: ".custom-video",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-grid-layout-text-content p", {
    y: "100%",
    opacity: 1,
    duration: 1.5,
    delay: 0.4,
    ease: "expoScale(0.5,7,none)",

    scrollTrigger: {
      trigger: ".custom-grid-layout-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-grid-layout-text-content-images img", {
    y: "100%",
    opacity: 1,
    duration: 1.5,
    delay: 0.4,
    ease: "power4.out",
    scrollTrigger: {
      trigger: ".custom-grid-layout-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.to(".custom-grid-layout-image", {
    // y: "100%",
    opacity: 1,
    duration: 2,
    delay: 0.6,
    ease: "power4.out",
    scrollTrigger: {
      trigger: ".custom-grid-layout-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-brand-story-text-wrapper p", {
    y: "100%",
    opacity: 1,
    duration: 1.5,
    delay: 0.6,
    ease: "expoScale(0.5,7,none)",
    scrollTrigger: {
      trigger: ".custom-brand-story-container",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-review-txt-content p", {
    y: "100%",
    opacity: 1,
    duration: 1.2,
    delay: 0.5,
    ease: "expoScale(0.5,7,none)",
    scrollTrigger: {
      trigger: ".custom-review-section-wrapper",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  //Discover Page
  gsap.utils.toArray(".custom-text-and-image-wrapper").forEach((section) => {
    gsap.from(section.querySelectorAll(".custom-text-n-img-text-content p"), {
      y: "100%",
      opacity: 0,
      duration: 1.5,
      stagger: 0.2,
      ease: "expoScale(0.5,7,none)",
      scrollTrigger: {
        trigger: section,
        start: "top 50%",
      },
    });

    gsap.from(
      section.querySelectorAll(".custom-text-n-img-image-wrapper img"),
      {
        y: "100%",
        opacity: 0,
        duration: 1.5,
        stagger: 0.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: section,
          start: "top 50%",
        },
      },
    );
  });

  //Product
  gsap.from(".custom-product-page-image-wrapper", {
    y: 50,
    opacity: 1,
    duration: 1,
    // delay: 0.4,
    ease: "expoScale(0.5,7,none)",
    scrollTrigger: {
      trigger: ".custom-product-page-wrapper",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-product-price-wrapper span", {
    y: "100%",
    opacity: 1,
    duration: 1,
    // delay: 0.4,
    ease: "expoScale(0.5,7,none)",
    scrollTrigger: {
      trigger: ".custom-product-page-wrapper",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });

  gsap.from(".custom-product-page-title", {
    y: "100%",
    opacity: 1,
    duration: 1,
    // delay: 0.4,
    ease: "expoScale(0.5,7,none)",
    scrollTrigger: {
      trigger: ".custom-product-page-wrapper",
      scroller: "body",
      // markers: true,
      start: "top 50%",
    },
  });
});
